<template>
  <v-dialog v-model="dialog" max-width="600" @click:outside="cancel">
    <v-form ref="form" v-model="valid">
      <v-card flat>
        <v-card-title>
          Choose an email to run as
          <v-spacer></v-spacer>
          <v-btn icon @click="cancel">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pb-0">
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="runAsEmail"
                label="Email"
                maxlength="100"
                :rules="[$rules.required, $rules.email]"
                required
                outlined
                @keydown.enter.prevent="save"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="primary" :loading="saving" @click="save">
            Run As
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import { setRunAs } from "@/helpers/local";
export default {
  name: "RunAsDialog",
  components: {},
  data: () => ({
    dialog: false,
    saving: false,
    category: {},
    runAsEmail: "",
    valid: false
  }),
  watch: {},
  computed: {
    ...mapGetters({})
  },
  methods: {
    cancel() {
      this.dialog = false;
      this.$emit("cancel");
    },
    save() {
      if (this.$refs.form.validate()) {
        setRunAs(this.runAsEmail);
      }
    },
    showDialog() {
      this.dialog = true;
      this.runAsEmail = "";
    }
  }
};
</script>
